import React, { useMemo, useState } from "react";
import MasterService from "../../../../../services/master/MasterService";
import UserService from "../../../../../services/user/UserService";
import PbUmkuService from "../../../../../services/pbumku/PbumkuService";
import { Col, Form, Row } from "react-bootstrap";
import { AsyncPaginate } from "react-select-async-paginate";
import { FaChevronLeft, FaSave } from "react-icons/fa";

const ViewCbibHeader = ({ dataHeader, cancelHeader, saveHeader }) => {
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    let masterService = useMemo(() => new MasterService(), [])
    let userService = useMemo(() => new UserService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [keyForSecondSelect, setKeyForSecondSelect] = useState(0)
    const [valueSearchPropOpt, setValueSearchPropOpt] = useState(null)
    const loadOptionPropinsi = async (search, loadedOption, { page = 1 }) => {
        const response = await masterService.listPropinsi(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangePropOpt = e => {
        setValueSearchPropOpt(e)
        setKeyForSecondSelect(prevKey => prevKey + 1)
    }
    const [valueSearchKotaOpt, setValueSearchKotaOpt] = useState(null)
    const loadOptionKota = async (search, loadedOption, { page = 1 }) => {
        const response = await masterService.listKota(valueSearchPropOpt.kodePropinsi, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeKotaOpt = e => {
        // console.log(e)
        setValueSearchKotaOpt(e)
    }

    const [valueJenisBenihOpt, setValueJenisBenihOpt] = useState(null)
    async function loadOptionJenisBenih(search, loadedOption, { page }) {
        const options = [
            {
                value: '1',
                label: 'Induk'
            },
            {
                value: '2',
                label: 'Telur'
            },
            {
                value: '3',
                label: 'Larva'
            }
        ]
        return {
            options: options
        }
    }
    const onChangeJenisBenihOpt = e => {
        setValueJenisBenihOpt(e)
    }

    const [valueSkalaUsahaOpt, setValueSkalaUsahaOpt] = useState(null)
    async function loadOptionSkalaUsaha(search, loadedOption, { page }) {
        const options = [
            {
                value: '1',
                label: 'Mikro Kecil'
            },
            {
                value: '2',
                label: 'Menengah Besar'
            }
        ]
        return {
            options: options
        }
    }
    const onChangeSkalaUsahaOpt = e => {
        setValueSkalaUsahaOpt(e)
    }

    const [valueTingkatResikoOpt, setValueTingkatResikoOpt] = useState(null)
    async function loadOptionTingkatResiko(search, loadedOption, { page }) {
        const options = [
            {
                value: '1',
                label: 'Rendah'
            },
            {
                value: '2',
                label: 'Tinggi'
            }
        ]
        return {
            options: options
        }
    }
    const onChangeTingkatResikoOpt = e => {
        setValueTingkatResikoOpt(e)
    }

    return (
        <>
            <div className="form-card text-start">
                <div className="row mb-3 mt-3">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Umum</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Unit Pembenihan<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control type="text" placeholder="Nama Unit Pembenihan" className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Penanggung Jawab<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control type="text" placeholder="Nama Penanggung Jawab" className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Alamat Unit Pembenihan<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control as="textarea" rows={4} placeholder="Alamat Unit Pembenihan" className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Propinsi <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="8">
                                            <AsyncPaginate
                                                loadOptions={loadOptionPropinsi}
                                                value={valueSearchPropOpt}
                                                getOptionLabel={(option) => option.uraianPropinsi}
                                                getOptionValue={(option) => option.kodePropinsi}
                                                additional={{
                                                    page: 1
                                                }}
                                                onChange={onChangePropOpt}
                                                isDisabled={localStorage.getItem('isEditPrimer') === '0' ? true : false}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Kota <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="8">
                                            <AsyncPaginate
                                                key={keyForSecondSelect}
                                                loadOptions={loadOptionKota}
                                                value={valueSearchKotaOpt}
                                                getOptionLabel={(option) => option.uraianKota}
                                                getOptionValue={(option) => option.kodeKota}
                                                additional={{
                                                    page: 1
                                                }}
                                                onChange={onChangeKotaOpt}
                                                isDisabled={localStorage.getItem('isEditPrimer') === '0' ? true : false}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Tahun Pendirian<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="2">
                                            <Form.Control type="text" placeholder="YYYY" maxLength={4} className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Tahun Mulai Beroperasi<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="2">
                                            <Form.Control type="text" placeholder="YYYY" maxLength={4} className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Produksi</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Jenis Benih<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="3">
                                            <AsyncPaginate
                                                loadOptions={loadOptionJenisBenih}
                                                value={valueJenisBenihOpt}
                                                getOptionValue={(option) => option.value}
                                                getOptionLabel={(option) => option.label}
                                                additional={{
                                                    page: 0,
                                                }}
                                                onChange={onChangeJenisBenihOpt}
                                                isDisabled={localStorage.getItem('isEditPrimer') === '0' ? true : false}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Asal Benih<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control type="text" placeholder="Asal Benih" className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Alamat Asal Benih<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control as="textarea" rows={3} placeholder="Alamat Asal Benih" className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Kapasitas Produksi<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="3">
                                            <Form.Control type="text" placeholder="kapasitas" className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">ekor / tahun</Form.Label>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Produksi Riil Rata-Rata Per Tahun<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="3">
                                            <Form.Control type="text" placeholder="produksi riil" className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">ekor / tahun</Form.Label>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>

                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Jumlah Siklus per Tahun<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="4">
                                            <Form.Control type="text" placeholder="Jumlah Siklus" className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Skala Usaha<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="4">
                                            <AsyncPaginate
                                                loadOptions={loadOptionSkalaUsaha}
                                                value={valueSkalaUsahaOpt}
                                                getOptionValue={(option) => option.value}
                                                getOptionLabel={(option) => option.label}
                                                additional={{
                                                    page: 0,
                                                }}
                                                onChange={onChangeSkalaUsahaOpt}
                                                isDisabled={localStorage.getItem('isEditPrimer') === '0' ? true : false}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Tingkat Resiko<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="4">
                                            <AsyncPaginate
                                                loadOptions={loadOptionTingkatResiko}
                                                value={valueTingkatResikoOpt}
                                                getOptionValue={(option) => option.value}
                                                getOptionLabel={(option) => option.label}
                                                additional={{
                                                    page: 0,
                                                }}
                                                onChange={onChangeTingkatResikoOpt}
                                                isDisabled={localStorage.getItem('isEditPrimer') === '0' ? true : false}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3 mt-3">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Manajer Pengendali Mutu (MPM)</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama MPM<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control type="text" placeholder="Nama Manajer Pengendali Mutu (MPM)" className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Sertifikat MPM<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control type="text" placeholder="Nomor Sertifikat" className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Tahun Kelulusan<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="2">
                                            <Form.Control type="text" placeholder="YYYY" maxLength={4} className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Telepon/HP<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="6">
                                            <Form.Control type="text" placeholder="No Telp / HP" className="form-control-sm" disabled={localStorage.getItem('isEditPrimer') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    localStorage.getItem('isEditPrimer') === '1' ? <>
                        <button type="button" name="next" className="btn btn-primary next action-button float-end btn-sm" value="Next"><FaSave /> Simpan & Lanjutkan</button>
                        <button type="button" name="back" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Kembali" onClick={() => cancelHeader()} ><FaChevronLeft /> Batal</button>
                    </> :
                        <button type="button" name="back" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Kembali" onClick={() => cancelHeader()} ><FaChevronLeft /> Kembali</button>
                }
            </div>
        </>
    )
}

export default ViewCbibHeader